module.exports = __webpack_public_path__ + "img/cover-bg.540b1c28.png";